import { Converter } from '../types/converter';

export const frequencyWavelengthConverter: Converter = {
  id: 'frequencyWavelength',
  name: 'Frequency Wavelength Converter',
  icon: 'AudioWaveform',
  categories: ['light'],
  units: [
    // Frequency Units
    { name: 'Hertz', symbol: 'Hz', factor: 1 },
    { name: 'Exahertz', symbol: 'EHz', factor: 1e18 },
    { name: 'Petahertz', symbol: 'PHz', factor: 1e15 },
    { name: 'Terahertz', symbol: 'THz', factor: 1e12 },
    { name: 'Gigahertz', symbol: 'GHz', factor: 1e9 },
    { name: 'Megahertz', symbol: 'MHz', factor: 1e6 },
    { name: 'Kilohertz', symbol: 'kHz', factor: 1e3 },
    { name: 'Hectohertz', symbol: 'hHz', factor: 1e2 },
    { name: 'Dekahertz', symbol: 'daHz', factor: 10 },
    { name: 'Decihertz', symbol: 'dHz', factor: 0.1 },
    { name: 'Centihertz', symbol: 'cHz', factor: 0.01 },
    { name: 'Millihertz', symbol: 'mHz', factor: 1e-3 },
    { name: 'Microhertz', symbol: 'µHz', factor: 1e-6 },
    { name: 'Nanohertz', symbol: 'nHz', factor: 1e-9 },
    { name: 'Picohertz', symbol: 'pHz', factor: 1e-12 },
    { name: 'Femtohertz', symbol: 'fHz', factor: 1e-15 },
    { name: 'Attohertz', symbol: 'aHz', factor: 1e-18 },
    { name: 'Cycle per Second', symbol: 'cps', factor: 1 },

    // Wavelength Units
    { name: 'Wavelength in Exametres', symbol: 'λEm', factor: 1e18 },
    { name: 'Wavelength in Petametres', symbol: 'λPm', factor: 1e15 },
    { name: 'Wavelength in Terametres', symbol: 'λTm', factor: 1e12 },
    { name: 'Wavelength in Gigametres', symbol: 'λGm', factor: 1e9 },
    { name: 'Wavelength in Megametres', symbol: 'λMm', factor: 1e6 },
    { name: 'Wavelength in Kilometres', symbol: 'λkm', factor: 1e3 },
    { name: 'Wavelength in Hectometres', symbol: 'λhm', factor: 1e2 },
    { name: 'Wavelength in Dekametres', symbol: 'λdam', factor: 10 },
    { name: 'Wavelength in Metres', symbol: 'λm', factor: 1 },
    { name: 'Wavelength in Decimetres', symbol: 'λdm', factor: 0.1 },
    { name: 'Wavelength in Centimetres', symbol: 'λcm', factor: 0.01 },
    { name: 'Wavelength in Millimetres', symbol: 'λmm', factor: 1e-3 },
    { name: 'Wavelength in Micrometres', symbol: 'λµm', factor: 1e-6 },
    { name: 'Wavelength in Nanometres', symbol: 'λnm', factor: 1e-9 },

    // Atomic/Particle Wavelength Units
    { name: 'Electron Compton Wavelength', symbol: 'λc', factor: 2.42631023867e-12 },
    { name: 'Proton Compton Wavelength', symbol: 'λc,p', factor: 1.32140985539e-15 },
    { name: 'Neutron Compton Wavelength', symbol: 'λc,n', factor: 1.31959090481e-15 }
  ]
};
